import { render, staticRenderFns } from "./BookingVisitListMobile.vue?vue&type=template&id=0dc70e6e"
import script from "./BookingVisitListMobile.vue?vue&type=script&lang=js"
export * from "./BookingVisitListMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports